import React from 'react';
import { cl } from '../../../components/utils/utils';
import styles from './pearlDoser.module.css'


function minsToHHMM(dayMins) {
  const h = Math.floor(dayMins / 60);
  const m = dayMins % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

function hhmmToMins(hhmm) {
  if (!hhmm) return 0;
  const [h, m] = hhmm.split(':').map(Number);
  return h * 60 + m;
}

export default class Schedule extends React.Component {
  constructor(props) {
    super(props);
//     cl(props);
    this.recipeIds=new Array(6)
    this.state = {
      durStrs:this.makeDurStrs()
//       durStrs: props.schedule.map(
//         (s) => (s.recipeId=="none")?"00:00":minsToHHMM(s.durMins)
//       ),
    };
  }

  makeDurStrs=()=>{
    return this.props.schedule.map(s=>{
      return (s.recipeId=="none")?"00:00":minsToHHMM(s.durMins)
    })
  }

  updateDurStrs=()=>{this.setState({durStrs:this.makeDurStrs()})}

  checkScheduleNone=()=>{
    let st=this.state
    let durStrs=st.durStrs.slice(0)
    let changed=false
//     cl(st.recipeId)
//     cl(this.recipeIds)
    this.props.schedule.forEach((s,i)=>{
//       cl(s)
//       cl(this.recipeIds[i])
//       cl(durStrs[i])
      if((s.recipeId=="none")&&(this.recipeIds[i]!="none")){
        if(durStrs[i]!="00:00"){
          durStrs[i]="00:00"
//           cl("setting time change")
          this.props.onChange({type:"time",index:i+1,value:0})
          changed=true
        }
      }
      this.recipeIds[i]=s.recipeId
    })
    if(changed)(this.setState({durStrs:durStrs}))
  }

  componentDidUpdate=(prevProps)=>{
    this.checkScheduleNone()
  }

  parseDuration(str) {
    const [h = 0, m = 0] = str.split(':').map(Number);
    return (h || 0) * 60 + (m || 0);
  }

  handleDurationChange(i, value) {
    if (!/^\d{0,2}:\d{0,2}$/.test(value)) return;

    const [hStr = '', mStr = ''] = value.split(':');

    const h = hStr === '' ? 0 : Number(hStr);
    const m = mStr === '' ? 0 : Number(mStr);

    if (h > 23 || m > 59) return;

    const durStrs = [...this.state.durStrs];
    durStrs[i] = value;
    this.setState({ durStrs });

    const mins = this.parseDuration(value);

    this.props.onChange({
      type: 'duration',
      index: i + 1,
      value: mins,
    });
  }

  handleDurationBlur(i) {
    const {schedule}=this.props
//     const mins = this.parseDuration(this.state.durStrs[i]);
    const mins = schedule[i].durMins;
    const normalized = minsToHHMM(mins);
    const durStrs = [...this.state.durStrs];
    durStrs[i] = normalized;
    this.setState({ durStrs });
    this.props.onChange({
      type: 'err',
      index: i,
      value: false,
    });
  }

  render() {
    const { recipeNames, schedule, onChange } = this.props;
    const sorted = [...recipeNames].sort((a, b) => a.name.localeCompare(b.name));

    return (
      <table style={{ borderCollapse: 'separate', borderSpacing: '8px 4px' }}
      className={styles.initTab}
      >
        <thead>
          <tr>
            <th style={{ padding: '4px 8px', textAlign: 'left' }}>Idx</th>
            <th style={{ padding: '4px 8px', textAlign: 'left' }}>Recipe</th>
            <th style={{ padding: '4px 8px', textAlign: 'left' }}>Start</th>
            <th style={{ padding: '4px 8px', textAlign: 'left' }}>Duration</th>
          </tr>
        </thead>
        <tbody>

          {schedule.slice(0,6).map((sched,i) => {
            const row = schedule[i];
            let bg=(row.err)?"#FFEEEE":"white"
            return (
              <tr key={i} style={{background:bg}}>
                <td style={{ padding: '4px 8px' }}>{i + 1}</td>
                <td style={{ padding: '4px 8px' }}>
                  <select
                    className={styles.stdSelect}
                    value={row.recipeId}
                    onChange={(e) =>
                      onChange({ type: 'recipe', index: i + 1, value: e.target.value })
                    }
                  >
                    <option value="none">Select a Recipe</option>
                    {sorted.map(({ recipeId, name },i) => (
                      <option key={i} value={recipeId}>
                        {name}
                      </option>
                    ))}
                  </select>
                </td>
                <td style={{ padding: '4px 8px' }}>
                  <input
                    className={styles.noMarg}
                    type="time"
                    value={minsToHHMM(row.dayMins)}
                    onChange={(e) => {
                      const mins = hhmmToMins(e.target.value);
                      onChange({ type: 'time', index: i + 1, value: mins });
                    }}
                  />
                </td>
                <td style={{ padding: '4px 8px' }}>
                  <input className={[styles.inlineCont,styles.wid2].join(' ')}
                    type="text"
                    placeholder="00:00a"
                    inputMode="numeric"
                    title="Duration (hours:minutes)"
                    value={this.state.durStrs[i]}
                    onChange={(e) => this.handleDurationChange(i, e.target.value)}
                    onBlur={() => this.handleDurationBlur(i)}
                  />{' '}
                  (HH:MM)
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}
